import React, { useEffect, useState } from 'react';
import { Box } from '@material-ui/core';

import Modal, { ModalContents, ModalTitle } from 'components/Modal/Modal';
import { FilesUpload } from 'containers/FilesUpload/FilesUpload';

interface UploadPacModalProps {
  isModalOpen: boolean;
  onClose: () => void;
  sendPacUploadEmailNotification: (message: string) => void;
}

export const UploadPacModal = ({
  isModalOpen,
  onClose: onCloseCallback,
  sendPacUploadEmailNotification,
}: UploadPacModalProps) => {
  const [publicFileUrl, setPublicFileUrl] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (!publicFileUrl) {
      return;
    }
    const uploadedFileName = new URL(publicFileUrl).pathname.split('/').pop();
    if (!uploadedFileName) {
      throw new Error('File URL could not be parsed.');
    }

    sendPacUploadEmailNotification(uploadedFileName);
  }, [sendPacUploadEmailNotification, publicFileUrl]);

  const onClose = () => {
    setPublicFileUrl(undefined);
    onCloseCallback();
  };

  return (
    <Modal style={{ zIndex: 1200 }} open={isModalOpen} fullWidth onClose={onClose}>
      <ModalContents
        onClickClose={onClose}
        body={
          <Box mb={6}>
            <ModalTitle size="large">Upload a CSV file of your PAC</ModalTitle>
            <FilesUpload
              acceptedTypes={['text/csv']}
              s3Acl="private"
              s3Bucket="secure"
              onChange={(uploadedFiles, uploadInProgress) => {
                if (!isModalOpen || uploadInProgress || !uploadedFiles.length) {
                  return;
                }

                const { status: fileStatus, publicUrl: incomingPublicUrl } = uploadedFiles[0];

                if (fileStatus !== 'uploaded') {
                  return;
                }

                setPublicFileUrl(incomingPublicUrl);
              }}
              multiple={false}
            />
          </Box>
        }
      />
    </Modal>
  );
};
